import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import React from 'react';
import DesktopAdhesionGak from './gak/DesktopAdhesion';
import DesktopAdhesionFs from './freestar/Adhesion';
const DesktopAdhesion = ({ safety ='off'  })=>{
    const isFreestar = useFlag('ads_freestar');
    if (isFreestar) {
        return /*#__PURE__*/ React.createElement(DesktopAdhesionFs, {
            safety: safety
        });
    }
    return /*#__PURE__*/ React.createElement(DesktopAdhesionGak, {
        safety: safety
    });
};
DesktopAdhesion.displayName = 'DesktopAdhesion';
export default DesktopAdhesion;
